export const IMAGE_COMPRESSION_QUALITY = .6;
export const MAX_IMAGE_FILE_SIZE_IN_MB = 4;
export const MAX_IMAGE_FILE_SIZE_IN_BYTES = MAX_IMAGE_FILE_SIZE_IN_MB * 1024 * 1024;
export const MAX_IMAGE_DIMENSION_IN_PIXELS = 2000;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/image.ts